<!-- <template>
  <div class="payment-method-grid text-center">
    <a v-for="gateway in gateways" @click="onGatewayClicked(gateway,i)" :key="gateway.id" :class="{activeBank:selectedGateway && gateway.name === selectedGateway.name}" class="box filter-grayscale1 bg-color-ea px-2 pt-2">
      <div class="position-relative payment-method-img">
        <img :src="gateway.image" :alt="gateway.name">
      </div>
      <h6 class="fontsize-small text-color-666 my-2">درگاه {{ gateway.label }}</h6>
    </a>
  </div>
</template>

<script>
export default {
  name: "Gateways",

  props: {
    selectedGateway: Object
  },
  computed: {
    gateways() {
      let homeData = this.$store.getters['front/getHomeData'];
      return homeData ? homeData.gateways : [];
    },
  },
  mounted() {

    this.$store.commit('front/addHomeRetrievedEvent', () => {
      if (!this.selectedGateway && this.gateways.length) {
        this.onGatewayClicked(this.gateways[0])
      }
    })
  },
  methods: {
    
    onGatewayClicked(gateway) {
    
      this.$emit('gatewaySelected', gateway)
    }
  }
}
</script>

<style scoped>
.filter-grayscale1{

  filter: grayscale(1);
}
.activeBank{
  filter: grayscale(0)!important;
  border: 1px solid var(--color-theme);
  border-radius: 15px;
  
}
  .tick-box {
    position: absolute;
    z-index: 2;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
</style> -->

<template>
  <div>
    <div v-if="gateway">
      <!-- <template v-for="gateway in gateways">
        <button
          v-if="gateway.name != 'snapppay'"
          @click="onGatewayClicked(gateway, i)"
          :key="gateway.id"
          :class="{
            activeBank:
              selectedGateway && gateway.name === selectedGateway.name,
            disabledBtn: lodingSnappayWalet && gateway.name == 'snapppay',
          }"
          class="box filter-grayscale1 bg-color-ea px-2 pt-2"
        >
          <div class="position-relative payment-method-img">
           
            <img :src="gateway.image" :alt="gateway.name" />
          </div>
          <h6 class="fontsize-small text-color-666 my-2">
            درگاه {{ gateway.label }}
          </h6>
        </button>
      </template> -->
      <div v-if="lodingSnappay" class="payment-grid payment-grid-Skeleton">
        <Skeleton class="w-100 Skeleton" v-for="i in 2" :key="i"></Skeleton>
      </div>
      <form v-else class="payment-grid">
        <template>
          <label
            v-if="gateway.gatewayActive"
            :for="`CheckedGateway`"
            class="d-flex align-items-center"
            style="gap: 6px"
          >
            <input
              type="radio"
              :id="`CheckedGateway`"
              name="CheckedGateway"
              :value="gateway.gateway"
              v-model="selectedValue"
              @change="updateSelectedObject"
              :disabled="lodingSnappayWalet && !gateway.snapppay"
            />
            <figure class="box bg-color-ea m-0 snapppay-payment-method-img">
              <img src="../../../../assets/images/svgs/gateway.svg" alt="درگاه پرداخت" />
             
            </figure>
            <!-- <p class="description-snapPay">
              <span class="fontsize-small font-weight-bold my-2">
                درگاه {{ gateway.label }}</span
              >
            </p> -->
            <p class="description-snapPay">
              <span class="fontsize-small font-weight-bold my-2">
                درگاه پرداخت اینترنتی
                </span
              >
              <span class="fontsize-small text-color-666 my-2">
                تمامی کارت‌های عضو شتاب
               </span
              >
            </p>
          </label>

          <label
            v-if="gateway?.snapppay && snapPayValue"
            for="snapChecked"
            class="d-flex align-items-center"
            style="gap: 6px"
          >
            <input
              type="radio"
              id="snapChecked"
              name="CheckedGateway"
              :value="snapPayValue"
              v-model="selectedValue"
              @change="updateSelectedObject"
              :disabled="lodingSnappayWalet && snapPayValue?.name == 'snapppay'"
            />

            <picture
              v-if="snapPayValue"
              :class="{
                activeBankSnapPay:
                  selectedGateway &&
                  snapPayValue?.name === selectedGateway?.name,
                disabledBtn:
                  lodingSnappayWalet && snapPayValue?.name == 'snapppay',
              }"
              class="box bg-color-ea snapppay-payment-method-img-logo m-0"
            >
              <source
                media="(max-width:648px)"
                srcset="../../../../assets/images/SnappPay65.png"
              />
              <img src="../../../../assets/images/SnappPay70.png" />
            </picture>
            <p class="description-snapPay">
              <span class="fontsize-small font-weight-bold my-2">
                {{ snapPayValue?.label }}</span
              >
              <span class="fontsize-small text-color-666 my-2">
                {{ snapPayValue?.description }}</span
              >
            </p>
          </label>
        </template>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "Gateways",

  props: {
    selectedGateway: Object,
    snapPayValue: Object,
    lodingSnappayWalet: Boolean,
    lodingSnappay: Boolean,
  },
  data() {
    return {
      selectedValue: null,
      // selectedValue: this.snapPayValue ? this.snapPayValue : null,
      selectedObject: null,
    };
  },
  computed: {
    gateway() {
      return this.$store.getters["front/getGateways"];
      // let homeData = this.$store.getters["front/getHomeData"];
      // return homeData ? homeData.new-gateways : [];
      // return homeData ? homeData.gateways : [];
    },
  },
  mounted() {
    console.log(this.gateways, "this.gatewaysthis.gatewaysthis.gateways");
    this.$store.commit("front/addHomeRetrievedEvent", () => {
      if (this.gateway.gatewayActive && this.gateway.gateway) {
        // if (this.snapPayValue != null) {
        //   this.onGatewayClicked(this.snapPayValue);
        // } else {
        //   this.onGatewayClicked(this.gateways[0]);
        //   document.getElementById("CheckedGateway0").click();
        // }
        this.onGatewayClicked(this.gateway.gateway);
        document.getElementById("CheckedGateway").click();
      } else {
        this.onGatewayClicked(this.snapPayValue);
        document.getElementById("snapChecked").click();
      }
    });
  },

  watch: {
    // snapPayValue: {
    //   handler(newOptions) {
    //     this.selectedValue = newOptions; // دقیقاً همون reference
    //   },
    //   immediate: true, // این باعث میشه همون لحظه‌ای که component mount میشه هم اجرا بشه
    // },
  },
  methods: {
    onGatewayClicked(gateway) {
      this.$emit("gatewaySelected", gateway);
    },
    updateSelectedObject() {
      this.$emit("gatewaySelected", this.selectedValue);
    },
  },
};
</script>

<style scoped>
.Skeleton {
  height: 80px;
}
.payment-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem 0;
}
.payment-grid-Skeleton {
  gap: 10px;
}
.snapppay-payment-method-img {
  min-width: 75px;
  min-height: 75px;
  width: 75px;
  height: 75px;
}
.description-snapPay {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0;
}
.description-snapPay span {
  margin: 0 !important;
  font-size: 14px;
  text-align: right;
}
.snapppay-payment-method-img img {
  width: 100%;
  height: 100%;
}
.payment-grid input {
  accent-color: #15cdb7;
  width: 16px;
  height: 16px;
}
.payment-grid label {
  cursor: pointer;
}
@media screen and (max-width: 1040px) {
  .payment-grid {
    grid-template-columns: repeat(1, 1fr);
    gap: 1rem;
  }
}
@media screen and (max-width: 648px) {
  .snapppay-payment-method-img {
    width: 65px;
    height: 65px;
    min-width: 65px;
    min-height: 65px;
  }
  .description-snapPay {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0;
  }
  .description-snapPay span {
    margin: 0 !important;
    font-size: 14px;
  }
}
.filter-grayscale1 {
  filter: grayscale(1);
}
.activeBank {
  filter: grayscale(0) !important;
  border: 1px solid var(--color-theme);
  border-radius: 15px;
}

.tick-box {
  position: absolute;
  z-index: 2;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.disabledBtn * {
  color: #fff;
}
</style>
